import React from 'react';

class LoadingData extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      
    }
  }

  render() {
    let LoadingContent = (<div className="loading-content"></div>)
    return (
      <div className="loading-data">
        <div className="box-items">
          <div className="box-forward ">
            <div className="group-box">
              <div className="items-form">
                <div className="rows"> 
                  <div className="col-input">{LoadingContent}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="group-box">
          <div className="inline-bottom">
            <div className="items-form">
              <div className="rows">
                  <div className="col-input">{LoadingContent}</div>
                  <div className="col-input">{LoadingContent}</div>
                  <div className="col-input">{LoadingContent}</div>
              </div>
            </div>
            <div className="items-form">
                <div className="rows">
                    <div className="col-input">{LoadingContent}</div>
                    <div className="col-input">{LoadingContent}</div>
                    <div className="col-input">{LoadingContent}</div>
                    <div className="col-input">{LoadingContent}</div>
                    <div className="col-input">{LoadingContent}</div>
                </div>
            </div>
            <div className="items-form">
                <div className="rows">
                   <div className="col-input">{LoadingContent}</div>
                    <div className="col-input">{LoadingContent}</div>
                    <div className="col-input">{LoadingContent}</div>
                    <div className="col-input">{LoadingContent}</div>
                    <div className="col-input">{LoadingContent}</div>
                    <div className="clearfix"></div>
                 </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingData;


// WEBPACK FOOTER //
// ./src/components/layout/partials/LoadingData.jsx